// extracted by mini-css-extract-plugin
export default {"menu":"wtWVgZ","catalog":"G0XGaS","other":"X0CX37"};